import React from "react";
import ViewRecruitmentRequirement from "./ViewRecruitmentRequirement";
import { Form } from "antd";

const index = ({
  dataDetail,
  isModalViewRecruitment,
  onCancelViewRecruitment,
  onFinishEdit,
  isDisableForm,
  setIsDisableForm,
  handleChangeUpload,
  uploadFileRec,
  loading,
}) => {
  const [form] = Form.useForm();

  return (
    <div>

      <ViewRecruitmentRequirement
        dataDetail={dataDetail}
        form={form}
        isModalViewRecruitment={
          isModalViewRecruitment
        }
        onCancelViewRecruitment={
          onCancelViewRecruitment
        }
        onFinishEdit={onFinishEdit}
        isDisableForm={isDisableForm}
        setIsDisableForm={setIsDisableForm}
        handleChangeUpload={handleChangeUpload}
        uploadFileRec={uploadFileRec}
        loading={loading}
      />
    </div>
  );
};

export default index;
